import * as React from "react"
import {formatProductsUnits} from "@ui-seeker/utils";


export default function reachColumn() {
    return {
        name: 'reach', label: 'nº Banners Views',
        options: {
            filter: false,
            setCellHeaderProps: () => ({ sx: { textAlign: 'center' } }),
            setCellProps: () => ({ sx: { textAlign: "center", fontSize: '0.875rem' } }),
            customBodyRowRender: (value) => formatProductsUnits(value)
        }
    }
}